import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import isPermissionEnabled from "common/isPermissionEnabled"
import { getGlobalSettingByType } from "store/actions/globalSettingAction"

/**
 * Resolves the tenant fast-moving icon URL from global delivery settings.
 */
export const useFastMovingIconUrl = (enabled = true) => {
  const dispatch = useDispatch()
  const { fastMovingDeliverySettings } = useSelector(
    state => state.GlobalSettings || {}
  )
  const { userRole, accountType } = useSelector(state => state.Login || {})
  const canViewDeliverySettings = isPermissionEnabled(
    userRole,
    59,
    "delivery_settings_1",
    accountType
  )
  const [iconUrl, setIconUrl] = useState("")
  const [settingsEnabled, setSettingsEnabled] = useState(false)

  useEffect(() => {
    if (!enabled || !canViewDeliverySettings) {
      setIconUrl("")
      setSettingsEnabled(false)
      return
    }
    dispatch(getGlobalSettingByType({ type: "fastMovingDeliverySettings" }))
  }, [dispatch, enabled, canViewDeliverySettings])

  useEffect(() => {
    if (!canViewDeliverySettings) return
    const nested =
      fastMovingDeliverySettings?.fastMovingDeliverySettings ||
      fastMovingDeliverySettings ||
      {}
    const url =
      typeof nested.iconUrl === "string" ? nested.iconUrl.trim() : ""
    setIconUrl(url)
    setSettingsEnabled(nested.enabled === true || nested.enabled === "true")
  }, [canViewDeliverySettings, fastMovingDeliverySettings])

  return {
    iconUrl,
    settingsEnabled,
  }
}
